import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { catchError, finalize, map, of, take, tap } from 'rxjs'
import { LoadingOverlay } from '@features/loading-overlay/loading-overlay.service'
import { APP_ROUTE_NAMES } from '@app/app.routes'
import { ProductService } from "@features/product/product.service"
import { CalculatorState } from "@features/product/calculator/calculator.state"

export const ensureCanLoadCalculator: CanActivateFn = () => {
  const router = inject(Router)
  const overlay = inject(LoadingOverlay)

  const products = inject(ProductService)
  const calcState = inject(CalculatorState)

  overlay.show()

  const parametersAvailable$ = products.current().pipe(
    take(1),
    tap(product => {
      calcState.presetProduct(product)
    }),
    map(Boolean),
    catchError(() => of(false)),
    finalize(() => {
      overlay.hide()
    })
  )

  return parametersAvailable$.pipe(
    map(available => available ? true : router.createUrlTree([APP_ROUTE_NAMES.PROFILE])),
  )
}
